<template>
  <div>
    <b-row class="no-gutters row-title">
      <b-col xl="3" class="text-center text-sm-left mb-3 mb-sm-0 w-auto">
        <h1 class="mr-sm-4 header-main text-uppercase">รายการผู้ดูแลระบบ</h1>
      </b-col>

      <div class="d-flex">
        <form @submit.prevent class="">
          <b-input-group class="panel-input-serach">
            <b-form-input
              id="product-search"
              class="input-serach"
              placeholder="ค้นหาอีเมล"
              v-model="filter.search"
              v-on:keyup.13="enterFilter"
            ></b-form-input>
            <b-input-group-prepend @click="onSubmitFilter">
              <span class="icon-input m-auto pr-2">
                <font-awesome-icon icon="search" title="View" />
              </span>
            </b-input-group-prepend>
          </b-input-group>
        </form>
        <b-button
          class="btn-main w-50 border-radius-0 ml-2"
          @click="$router.push('/admin/details/0?brandID=1').catch(() => {})"
        >
          สร้าง
        </b-button>
      
      </div>
    </b-row>
    <div class="table-section">
      <b-table
        responsive
        class="text-center table-list mb-0"
        striped
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
      >
        <template v-slot:cell(employeeId)="data">
          <div v-if="data.item.employeeId">
            <p class="md-0">{{ data.item.employeeId }}</p>
          </div>
          <div v-else>-</div>
        </template>

        <template v-slot:cell(createdTime)="data">
          <p class="mb-0">
            {{ data.item.createdTime | moment($formatDateTime) }}
          </p>
        </template>

        <template v-slot:cell(enabled)="data">
          <p v-if="data.item.enabled" class="mb-0 text-success">
            ใช้งาน
          </p>
          <p v-else class="mb-0 text-danger">
            ไม่ใช้งาน
          </p>
        </template>

        <template v-slot:cell(action)="data">
          <router-link :to="`/admin/details/${data.item.userGUID}?brandID=1  `">
            <font-awesome-icon class="pointer" icon="pencil-alt"
          /></router-link>
        </template>
      </b-table>

      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="form-inline justify-content-center justify-content-sm-end"
        >
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0 page-item"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>

          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filter.perPage"
            @change="handleChangePageSize"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      isBusy: false,
      filter: {
        serach: "",
        pageNo: 1,
        perPage: 10,
        status: [0, 1],
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      fields: [
        { key: "employeeId", label: "Admin ID", class: "w-100px text-nowrap" },
        { key: "email", label: "อีเมล", class: "w-100px text-nowrap" },
        { key: "firstname", label: "ชื่อ", class: "w-100px text-nowrap" },
        { key: "lastname", label: "นามสกุล", class: "w-100px text-nowrap" },
        {
          key: "createdTime",
          label: "วันที่ทำการสมัคร",
          class: "w-100px text-nowrap",
        },
        { key: "enabled", label: "สถานะ", class: "w-100px text-nowrap" },
        { key: "Action", label: "", class: "w-100px text-nowrap" },
      ],
    };
  },
  async created() {
    await this.getFilter();
    this.getAdminList();
  },
  methods: {
    getFilter(){
      if(this.$route.query.search){
        this.filter.search = this.$route.query.search;
      }
      if(this.$route.query.pageNo){
        this.filter.pageNo = parseInt(this.$route.query.pageNo) || 1;
      }
      if(this.$route.query.perPage){
        this.filter.perPage = parseInt(this.$route.query.perPage) || 10;
      }
    },
    setFilter(){
      this.$router.push({ path: '/admin', 
        query: { 
          brandID: this.$route.query.brandID,
          search: this.filter.search,
          pageNo: this.filter.pageNo,
          perPage : this.filter.perPage ,
        }
      }).catch(err => {});
    },
    async getAdminList(filter) {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/adminRole/List`, this.filter)
        .then((data) => {
          if (data.result) {
            this.rows = data.detail.count;
            this.items = data.detail.userProfileList;
          }
        });
      this.isBusy = false;
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.setFilter()
      this.getAdminList(this.filter);
    },
    handleChangePageSize(value) {
      this.filter.pageNo = 1;
      this.filter.perPage = value;
      this.setFilter()
      this.getAdminList();
    },
    onSubmitFilter(filter) {
      this.setFilter()
      this.getAdminList(this.filter);
    },
    enterFilter(event) {
      console.log(`event`, event);
      if (event.which === 13) {
        this.onSubmitFilter();
      }
    },
  },
};
</script>

<style scoped>
.row-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.table-section {
  background-color: white;
}
</style>
